import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Send } from "lucide-react";
import { api, errMsg, fmtDateTime, fileUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { StatusBadge } from "@/components/Status";
import { Input } from "@/components/ui/input";

export const Thread = ({ messages, mine = "customer" }) => (
  <div className="space-y-2" data-testid="complaint-thread">
    {messages.map((m, i) => (
      <div key={i} className={`flex ${m.from === mine ? "justify-end" : "justify-start"}`}>
        <div className={`max-w-[80%] rounded-2xl px-4 py-2 ${m.from === mine ? "bg-[#0D3B2B] text-white" : "border border-[#D2E0D8] bg-white text-[#0D3B2B]"}`}>
          <p className="text-[11px] font-bold opacity-70">{m.from === "admin" ? "Kindsaver team" : "Customer"}</p>
          <p className="whitespace-pre-wrap text-sm">{m.text}</p>
          <p className="mt-1 text-[10px] opacity-60">{fmtDateTime(m.at)}</p>
        </div>
      </div>
    ))}
  </div>
);

export default function ComplaintDetail() {
  const { cid } = useParams();
  const { t } = useApp();
  const nav = useNavigate();
  const [c, setC] = useState(null);
  const [msg, setMsg] = useState("");
  useEffect(() => { api.get(`/complaints/${cid}`).then((r) => setC(r.data)).catch((e) => { toast.error(errMsg(e)); nav("/help"); }); }, [cid]); // eslint-disable-line
  const send = async () => {
    if (!msg.trim()) return;
    try {
      const { data } = await api.post(`/complaints/${cid}/messages`, { message: msg });
      setC(data); setMsg("");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!c) return <p className="text-[#7B968B]">{t("Loading…")}</p>;
  return (
    <div className="space-y-4">
      <button onClick={() => nav("/help")} className="flex items-center gap-1 text-sm font-semibold text-[#2E9E6B]" data-testid="complaint-back-btn"><ArrowLeft className="h-4 w-4" />{t("Help and complaints")}</button>
      <div className="flex items-start justify-between">
        <div>
          <p className="font-display text-2xl font-extrabold text-[#0D3B2B]" data-testid="complaint-id">{c.complaint_id}</p>
          <p className="text-sm text-[#4A6358]">{t(c.category)}{c.booking_id ? ` · ${c.booking_id}` : ""}</p>
        </div>
        <StatusBadge status={c.status} testid="complaint-status" />
      </div>
      {c.photo_path && <img src={fileUrl(c.photo_path)} alt="" className="h-32 w-32 rounded-2xl object-cover" />}
      <Thread messages={c.messages} />
      {c.status !== "Resolved" && (
        <div className="flex gap-2">
          <Input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder={t("Write a message…")} className="h-12 rounded-xl bg-white" data-testid="complaint-reply-input" />
          <button onClick={send} className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#2E9E6B] text-white" data-testid="complaint-reply-send-btn"><Send className="h-5 w-5" /></button>
        </div>
      )}
    </div>
  );
}
